import React from 'react';

export const BurnIcon = () => (
  <img src="/images/fire.png" alt="Burn Icon" width="60" height="60" />
);

export const MintingIcon = () => (
    <img src="/images/e.webp" alt="Burn Icon" width="60" height="60" />
//   <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <rect x="15" y="20" width="30" height="35" rx="2" 
//       fill="#3498db"
//       stroke="#5DADE2"
//       strokeWidth="2"
//     />
//     <path d="M20 15H40C41.1046 15 42 15.8954 42 17V20H18V17C18 15.8954 18.8954 15 20 15Z" 
//       fill="#3498db"
//       stroke="#5DADE2"
//       strokeWidth="2"
//     />
//     <path d="M23 10H37C38.1046 10 39 10.8954 39 12V15H21V12C21 10.8954 21.8954 10 23 10Z" 
//       fill="#3498db"
//       stroke="#5DADE2"
//       strokeWidth="2"
//     />
//   </svg>
);

export const RewardIcon = () => (
    <img src="/images/reward.svg" alt="Burn Icon" width="60" height="60" />
//   <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <rect x="10" y="30" width="8" height="25" 
//       fill="#9B59B6"
//       stroke="#AF7AC5"
//       strokeWidth="2"
//     />
//     <rect x="26" y="20" width="8" height="35" 
//       fill="#9B59B6"
//       stroke="#AF7AC5"
//       strokeWidth="2"
//     />
//     <rect x="42" y="10" width="8" height="45" 
//       fill="#9B59B6"
//       stroke="#AF7AC5"
//       strokeWidth="2"
//     />
//   </svg>
);

export const BurnRewardIcon = () => (
    <img src="/images/be.png" alt="Burn Icon" width="60" height="60" />
//   <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M30 10C25 17 22 23 22 28C22 34.4 25.6 39 30 39C34.4 39 38 34.4 38 28C38 23 35 17 30 10Z" 
//       fill="#FF4D4D"
//       stroke="#FF6B6B"
//       strokeWidth="2"
//     />
//   </svg>
);

export const SecurityIcon = () => (
    <img src="/images/lock.png" alt="Burn Icon" width="60" height="60" />
//   <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M30 10L10 20V25C10 37.8 18.5 49.7 30 52C41.5 49.7 50 37.8 50 25V20L30 10Z" 
//       fill="#3498db"
//       stroke="#5DADE2"
//       strokeWidth="2"
//     />
//     <path d="M25 30L28 33L35 26" 
//       stroke="white"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
);

export const TransparentIcon = () => (
    <img src="/images/fat_t.png" alt="Burn Icon" width="60" height="60" />
//   <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <rect x="10" y="20" width="40" height="30" rx="2" 
//       fill="#9B59B6"
//       stroke="#AF7AC5"
//       strokeWidth="2"
//     />
//     <path d="M20 20V15C20 12.2386 22.2386 10 25 10H35C37.7614 10 40 12.2386 40 15V20" 
//       stroke="#AF7AC5"
//       strokeWidth="2"
//     />
//     <circle cx="30" cy="35" r="5" 
//       stroke="white"
//       strokeWidth="2"
//     />
//   </svg>
); 